"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.utils = exports.types = exports.transitions = exports.spacings = exports.formControl = exports.fonts = exports.effects = exports.colors = exports.checkbox = exports.buttons = exports.breakpoints = exports.border = void 0;
const border_1 = require("./border");
Object.defineProperty(exports, "border", { enumerable: true, get: function () { return border_1.border; } });
const breakpoints_1 = require("./breakpoints");
Object.defineProperty(exports, "breakpoints", { enumerable: true, get: function () { return breakpoints_1.breakpoints; } });
const buttons_1 = require("./buttons");
Object.defineProperty(exports, "buttons", { enumerable: true, get: function () { return buttons_1.buttons; } });
const checkbox_1 = require("./checkbox");
Object.defineProperty(exports, "checkbox", { enumerable: true, get: function () { return checkbox_1.checkbox; } });
const colors_1 = require("./colors");
Object.defineProperty(exports, "colors", { enumerable: true, get: function () { return colors_1.colors; } });
const effects_1 = require("./effects");
Object.defineProperty(exports, "effects", { enumerable: true, get: function () { return effects_1.effects; } });
const fonts_1 = require("./fonts");
Object.defineProperty(exports, "fonts", { enumerable: true, get: function () { return fonts_1.fonts; } });
const formControl_1 = require("./formControl");
Object.defineProperty(exports, "formControl", { enumerable: true, get: function () { return formControl_1.formControl; } });
const spacings_1 = require("./spacings");
Object.defineProperty(exports, "spacings", { enumerable: true, get: function () { return spacings_1.spacings; } });
const transitions_1 = require("./transitions");
Object.defineProperty(exports, "transitions", { enumerable: true, get: function () { return transitions_1.transitions; } });
const types_1 = require("./types");
Object.defineProperty(exports, "types", { enumerable: true, get: function () { return types_1.types; } });
const utils_1 = require("./utils");
Object.defineProperty(exports, "utils", { enumerable: true, get: function () { return utils_1.utils; } });
const baseTheme = (theme = {
    border: border_1.border,
    breakpoints: breakpoints_1.breakpoints,
    buttons: buttons_1.buttons,
    colors: colors_1.colors,
    checkbox: checkbox_1.checkbox,
    effects: effects_1.effects,
    fonts: fonts_1.fonts,
    spacings: spacings_1.spacings,
    transitions: transitions_1.transitions,
    types: types_1.types,
    formControl: formControl_1.formControl,
}) => ({
    theme,
    border: border_1.border,
    breakpoints: breakpoints_1.breakpoints,
    buttons: buttons_1.buttons,
    colors: colors_1.colors,
    checkbox: checkbox_1.checkbox,
    effects: effects_1.effects,
    fonts: fonts_1.fonts,
    spacings: spacings_1.spacings,
    transitions: transitions_1.transitions,
    types: types_1.types,
    formControl: formControl_1.formControl,
});
exports.default = baseTheme;
//# sourceMappingURL=baseTheme.js.map